module.exports = __webpack_public_path__ + "static/media/unlock-icon.b5544afe.svg";